var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgMail = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M2 7a3 3 0 0 1 3-3h14a3 3 0 0 1 3 3v10a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3V7Zm3-1a1 1 0 0 0-1 1v.51l8 6.223 8-6.222V7a1 1 0 0 0-1-1H5ZM4 16.586v-6.541l3.68 2.861L4 16.586ZM5.414 18h13.172l-3.856-3.856-1.502 1.168a2 2 0 0 1-2.456 0L9.27 14.144 5.414 18Zm10.907-5.094L20 16.586v-6.541l-3.68 2.861Z",
  fill: "currentColor"
})));
export default SvgMail;